var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column",attrs:{"id":"root"}},[_c('div',{staticClass:"header"},[(_vm.isLoggedIn)?[(_vm.isCustomer)?_c('CustomerNav'):_c('DefaultNav')]:[_c('LoginNav')]],2),_c('div',{staticClass:"container body"},[_c('LoginModal'),_c('nuxt')],1),_c('div',{staticClass:"footer"},[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }